import {GroupProps} from '@mantine/core';
import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import permissionGroupsKeys from '../util/permission-groups-keys';

const useCreatePermissionGroup = () => {
  const {create} = useInfiniteQueryHelpers();

  const onSuccess = (data: GroupProps) => {
    create(permissionGroupsKeys.list(), data);
  };

  return useApiMutation({
    url: '/permission-groups',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar grupo de permissões',
    redirectUrl: '/settings/permission-groups',
    onSuccess,
  });
};

export default useCreatePermissionGroup;
